import { AUDIT_METRICS, latestLoad } from './yfDataStatusUtils';

// Machine names, not translated labels: the file gets pivoted in a spreadsheet.
const CONNECTOR_COLUMNS = [
    'date',
    'connector',
    'account',
    'status',
    'unsupported_reason',
    'loaded_by',
    'loaded_at',
    'last_check',
];

const METRIC_COLUMN_NAMES = {
    costs: 'cost',
    installs: 'installs',
    clicks: 'clicks',
    impressions: 'impressions',
};

export const csvHeader = () => [
    ...CONNECTOR_COLUMNS,
    ...AUDIT_METRICS.flatMap(metric => {
        const name = METRIC_COLUMN_NAMES[metric];
        return [`singular_${name}`, `adnet_${name}`, `diff_${name}_percent`];
    }),
];

// A missing side is an empty cell, not 0. Values are unrounded and unabbreviated.
const _connectorRow = (connector, auditDate) => {
    const load = latestLoad(connector);
    const cells = [
        auditDate,
        connector.display_name,
        connector.label,
        connector.status,
        connector.unsupported_reason || '',
        load.pull_tag || '',
        load.loaded_at || '',
        connector.pulled_at || '',
    ];

    AUDIT_METRICS.forEach(metric => {
        const { adnet_value: adnetValue, singular_value: singularValue, percent } = connector.deltas[metric] || {};
        cells.push(_number(singularValue), _number(adnetValue), _number(percent));
    });

    return cells;
};

const _number = value => (value === null || value === undefined ? '' : String(value));

const _escape = cell => {
    const value = String(cell === null || cell === undefined ? '' : cell);
    return /[",\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
};

export const buildAuditCsv = (rows, auditDate) =>
    [csvHeader(), ...rows.map(connector => _connectorRow(connector, auditDate))]
        .map(cells => cells.map(_escape).join(','))
        .join('\n');

export const auditCsvFileName = auditDate => `yesterday-status-${auditDate}.csv`;

// The BOM stops Excel mangling non-ascii connector names.
export const downloadAuditCsv = (rows, auditDate) => {
    const blob = new Blob(['﻿', buildAuditCsv(rows, auditDate)], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = auditCsvFileName(auditDate);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
